export default {
      id: "profile-usage",
      viewBox: "0 0 32 32",
      url: "assets/" + "sprite.svg#profile-usage",
      toString: function () {
        return this.url;
      }
    }